/* unplugin-vue-components disabled */import { render } from "./daily.vue?vue&type=template&id=aec4a6c0&scoped=true"
import script from "./daily.vue?vue&type=script&lang=js"
export * from "./daily.vue?vue&type=script&lang=js"

import "./daily.vue?vue&type=style&index=0&id=aec4a6c0&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aec4a6c0"]])

export default __exports__